import { render, staticRenderFns } from "./CertifGradBundling.vue?vue&type=template&id=5f2aab9a&scoped=true"
import script from "./CertifGradBundling.vue?vue&type=script&lang=js"
export * from "./CertifGradBundling.vue?vue&type=script&lang=js"
import style0 from "./CertifGradBundling.vue?vue&type=style&index=0&id=5f2aab9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2aab9a",
  null
  
)

export default component.exports